<template>
  <div>
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <form
            @submit.prevent="submit"
            @keydown="form.onKeydown($event)"
            enctype="multipart/form-data"
          >
            <alert-error
              v-if="form.errors.get('message')"
              :form="form"
              :message="form.errors.get('message')"
            ></alert-error>
            <div class="row">
              <div class="col-md-12 col-lg-3">
                <div class="card mb-n1">
                  <div class="card-body mb-n2">
                    <div class="row">
                      <div class="col-12">
                        <div
                          class="d-flex flex-column align-items-center justify-content-center text-center"
                        >
                          <img
                            v-if="url_logo"
                            class="rounded-circle"
                            alt="Logo"
                            width="200"
                            height="200"
                            :src="url_logo"
                            data-holder-rendered="true"
                          />
                          <img
                            v-else
                            class="rounded-circle"
                            alt="Logo"
                            width="200"
                            height="200"
                            :src="URL_LOCAL_FILE + '/images/no-image.png'"
                            data-holder-rendered="true"
                          />
                          <div class="mt-3">
                            <p class="text-secondary mb-1">
                              {{ form.nom }}
                            </p>
                            <div>
                              <input
                                ref="logoUpload"
                                type="file"
                                style="display: none"
                                accept="image/*"
                                :class="{
                                  'is-invalid': form.errors.has('logo'),
                                }"
                                @change="onChangeLogo"
                              />
                              <has-error
                                :form="form"
                                field="logo"
                                class="mb-4"
                              ></has-error>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex"
                          :class="
                            url_logo !== null
                              ? 'justify-content-between'
                              : 'justify-content-center'
                          "
                        >
                          <b-button
                            size="sm"
                            variant="outline-custom-primary"
                            @click="chooseLogo"
                            ><i class="fas fa-image" aria-hidden="true"></i>
                            Changer
                          </b-button>
                          <b-button
                            v-if="url_logo"
                            size="sm"
                            variant="outline-danger"
                            @click="onClearLogo"
                            ><i class="fas fa-trash" aria-hidden="true"></i>
                            Supprimer</b-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-9">
                <div class="card">
                  <div class="card-body mb-n2">
                    <div class="row">
                      <div class="row border-bottom col-12 mt-n4 mb-2">
                        <div class="col-md-4 col-lg-3 mt-4 pt-1">
                          <div class="custom-control custom-radio mb-3">
                            <input
                              type="radio"
                              class="custom-control-input"
                              id="client"
                              v-model="form.statut"
                              :value="STATUTS.client"
                            />
                            <label class="custom-control-label" for="client"
                              >Client</label
                            >
                          </div>
                        </div>

                        <div class="col-md-4 col-lg-3 mt-4 pt-1">
                          <div class="custom-control custom-radio mb-3">
                            <input
                              type="radio"
                              class="custom-control-input"
                              id="prospect"
                              v-model="form.statut"
                              :value="STATUTS.prospect"
                            />
                            <label class="custom-control-label" for="prospect"
                              >Prospect</label
                            >
                          </div>
                        </div>

                        <div
                          class="col-md-4 d-flex justify-content-end col-lg-6 mt-4 pt-1"
                        >
                          <div class="custom-control custom-checkbox mb-3">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id="assujetti_tva"
                              v-model="form.assujetti_tva"
                            />
                            <label
                              class="custom-control-label"
                              for="assujetti_tva"
                              >Assujetti à la TVA ?</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="form-group">
                          <label for="nom"
                            >Nom {{ form.statut
                            }}<span class="text-danger">*</span></label
                          >
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('nom'),
                            }"
                            id="nom"
                            v-model="form.nom"
                            type="text"
                            placeholder="Nom"
                            maxlength="50"
                          />
                          <has-error :form="form" field="nom"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="form-group">
                          <label for="type"
                            >Type {{ form.statut }}
                            <span class="text-danger">*</span></label
                          >
                          <v-custom-select
                            label="nom"
                            id="type"
                            :options="types"
                            :reduce="(type) => type.uuid"
                            v-model="form.type"
                            placeholder="Type tiers"
                          >
                            <template v-slot:option="{ nom }">
                              <h5 style="margin: 0">{{ nom }}</h5>
                            </template>
                            <template #no-options> Aucune donnée </template>
                            <template #search="{ attributes, events }">
                              <input
                                id="type"
                                class="custom-select-height vs__search"
                                v-bind="attributes"
                                v-on="events"
                              />
                            </template>
                          </v-custom-select>
                          <input
                            type="hidden"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('type'),
                            }"
                          />
                          <has-error :form="form" field="type"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4 mt-lg-0">
                        <div class="form-group">
                          <label for="langue"
                            >Langue <span class="text-danger">*</span></label
                          >
                          <v-custom-select
                            label="nom"
                            id="langue"
                            :options="langues"
                            :reduce="(langue) => langue.uuid"
                            v-model="form.langue"
                            placeholder="Langue"
                          >
                            <template v-slot:option="{ nom }">
                              <h5 style="margin: 0">{{ nom }}</h5>
                            </template>
                            <template #no-options> Aucune donnée </template>
                            <template #search="{ attributes, events }">
                              <input
                                id="type"
                                class="custom-select-height vs__search"
                                v-bind="attributes"
                                v-on="events"
                              />
                            </template>
                          </v-custom-select>
                          <input
                            type="hidden"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('langue'),
                            }"
                          />
                          <has-error :form="form" field="langue"></has-error>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="email"
                            >Email <span class="text-danger">*</span></label
                          >
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('email'),
                            }"
                            id="email"
                            v-model="form.email"
                            type="email"
                            placeholder="Email"
                            maxlength="100"
                          />
                          <has-error :form="form" field="email"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="telephone">Téléphone </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('telephone'),
                            }"
                            id="telephone"
                            v-model="form.telephone"
                            type="text"
                            placeholder="Téléphone"
                            maxlength="20"
                          />
                          <has-error :form="form" field="telephone"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="fax">Fax </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('fax'),
                            }"
                            id="fax"
                            v-model="form.fax"
                            type="text"
                            placeholder="Fax"
                            maxlength="20"
                          />
                          <has-error :form="form" field="fax"></has-error>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="pays">Pays </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('pays'),
                            }"
                            id="pays"
                            v-model="form.pays"
                            type="text"
                            placeholder="Pays"
                            maxlength="50"
                          />
                          <has-error :form="form" field="pays"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="ville">Ville </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('ville'),
                            }"
                            id="ville"
                            v-model="form.ville"
                            type="text"
                            placeholder="Ville"
                            maxlength="50"
                          />
                          <has-error :form="form" field="ville"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="departement">Département </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('departement'),
                            }"
                            id="departement"
                            v-model="form.departement"
                            type="text"
                            placeholder="Département"
                            maxlength="50"
                          />
                          <has-error
                            :form="form"
                            field="departement"
                          ></has-error>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="code_postal">Code postal </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('code_postal'),
                            }"
                            id="code_postal"
                            v-model="form.code_postal"
                            type="text"
                            placeholder="Code postal"
                            maxlength="20"
                          />
                          <has-error
                            :form="form"
                            field="code_postal"
                          ></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="adresse">Adresse </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('adresse'),
                            }"
                            id="adresse"
                            v-model="form.adresse"
                            type="text"
                            placeholder="Adresse"
                            maxlength="100"
                          />
                          <has-error :form="form" field="adresse"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="site_web">Site web </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('site_web'),
                            }"
                            id="site_web"
                            v-model="form.site_web"
                            type="text"
                            placeholder="Site web"
                            maxlength="40"
                          />
                          <has-error :form="form" field="site_web"></has-error>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-body mb-n2">
                    <div class="row pt-3">
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="code_client">Code client </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('code_client'),
                            }"
                            id="code_client"
                            v-model="form.code_client"
                            type="text"
                            placeholder="Code client"
                            maxlength="30"
                          />
                          <has-error
                            :form="form"
                            field="code_client"
                          ></has-error>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="numero_tva">Numéro TVA </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('numero_tva'),
                            }"
                            id="numero_tva"
                            v-model="form.numero_tva"
                            type="text"
                            placeholder="Numéro TVA"
                            maxlength="20"
                          />
                          <has-error
                            :form="form"
                            field="numero_tva"
                          ></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="effectif">Effectif </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('effectif'),
                            }"
                            id="effectif"
                            v-model.number="form.effectif"
                            type="text"
                            placeholder="Effectif"
                          />
                          <has-error :form="form" field="effectif"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="capital">Capital </label>
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('capital'),
                            }"
                            id="capital"
                            v-model.number="form.capital"
                            type="text"
                            placeholder="Capital"
                          />
                          <has-error :form="form" field="capital"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 mt-n4">
                        <div class="form-group">
                          <label for="devise"
                            >Devise principale
                            <span class="text-danger">*</span></label
                          >
                          <v-custom-select
                            label="symbole"
                            id="devise"
                            :options="devises"
                            :reduce="(devise) => devise.uuid"
                            v-model="form.devise"
                            placeholder="Devise principale"
                          >
                            <template v-slot:option="{ symbole }">
                              <h5 style="margin: 0">{{ symbole }}</h5>
                            </template>
                            <template #no-options> Aucune donnée </template>
                            <template #search="{ attributes, events }">
                              <input
                                id="devise"
                                class="custom-select-height vs__search"
                                v-bind="attributes"
                                v-on="events"
                              />
                            </template>
                          </v-custom-select>
                          <input
                            type="hidden"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('devise'),
                            }"
                          />
                          <has-error :form="form" field="devise"></has-error>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-body mb-n2">
                    <div class="row pt-3">
                      <div class="col-md-12 col-lg-12 mt-n4 mt-lg-0">
                        <div class="form-group">
                          <label for="code_client">Affiliations </label>
                          <multiselect
                            v-model="affiliations"
                            :options="tiersList"
                            :multiple="true"
                            :hideSelected="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            selectLabel="Tapez Entrez pour selectionner"
                            placeholder="Filtrer par colonne"
                            label="nom"
                            track-by="id"
                          >
                            <template slot="option" slot-scope="{ option }">
                              <div class="d-flex flex-column mb-2">
                                <span class="h6 font-weight-bold mb-1">
                                  {{ option.nom }}
                                </span>
                                <span class="mb-1">
                                  <span class="font-weight-bold mr-2"
                                    >Type:</span
                                  >
                                  {{ option.type }}
                                </span>
                                <span v-if="option.email">
                                  <i class="fas fa-envelope mr-2"></i
                                  >{{ option.email }}
                                </span>
                              </div>
                            </template>
                          </multiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 mb-4">
              <div class="col-md-12 text-right">
                <ButtonLoader
                  :busy="form.busy"
                  type="submit"
                  customClass="btn btn-custom-primary w-40"
                  loadText="Traitement en cours..."
                  Text="Enregistrer"
                  style="min-width: 100px"
                ></ButtonLoader>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/crm/tiers_contact/tiers';
import { objectToFormData } from 'object-to-formdata';

import From from 'vform';
import config from '@/config';
export default {
  data() {
    return {
      form: new From({
        type: null,
        langue: null,
        devise: null,
        statut: '',
      }),

      affiliations: [],
      tiersList: [],

      STATUTS: {
        client: 'client',
        prospect: 'prospect',
      },
      types: [],
      devises: [],
      langues: [],
      url_logo: null,
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },

  methods: {
    chooseLogo() {
      this.$refs.logoUpload.click();
    },
    onChangeLogo(e) {
      const file = e.target.files[0];
      this.form.logo = file;
      this.url_logo = global.URL.createObjectURL(file);
      this.form.clear_logo = false;
    },
    onClearLogo() {
      this.form.logo = null;
      this.url_logo = null;
      this.form.clear_logo = true;
    },
    init() {
      this.types = [];
      this.devises = [];
      this.langues = [];
      this.contacts = [];
      this.banques = [];
      this.notes = [];
      this.url_logo = null;

      this.id = this.$route.params.id;

      window.axios
        .all([
          window.axios.get(URL.GET_REQUIREMENTS),
          window.axios.get(URL.TIERS + '/' + this.id),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.types = resp1.data.types;
            this.devises = resp1.data.devises;
            this.langues = resp1.data.langues;
            this.tiersList = resp1.data.tiers;

            Object.assign(this.form, resp2.data.tiers);
            this.form.devise = this.form.devise.uuid;
            this.form.langue = this.form.langue.uuid;
            this.form.type = this.form.type.uuid;
            this.url_logo = this.form.url_logo;
            delete this.form.url_logo;

            this.affiliations = this.form.affiliations;

            if (this.form.prospect) {
              this.form.statut = this.STATUTS.prospect;
            } else {
              this.form.statut = this.STATUTS.client;
            }
          })
        )
        .catch();
    },
    submit() {
      if (this.form.statut === this.STATUTS.client) {
        this.form.client = true;
        this.form.prospect = false;
      }

      if (this.form.statut === this.STATUTS.prospect) {
        this.form.client = false;
        this.form.prospect = true;
      }

      this.form.affiliations = this.affiliations.map((a) => a.id);

      this.form._method = 'PUT';
      this.form
        .post(URL.TIERS + '/' + this.id, {
          transformRequest: [
            function (data) {
              return objectToFormData(data);
            },
          ],
        })
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
